<template>
  <div class="home">
    <banner v-if="!isedit" :bannerData="bannerData"></banner>
    <div v-else class="back-btn" @click="() => this.$router.push('/profile')"> &lt; 返回 </div>
    <div class="pc-title">请填写信息</div>
    <div class="user">
      <div class="user-title">参会人信息</div>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-position="top"
        label-width="100px"
        class="user-form"
      >
        <el-form-item
          v-for="(item, index) in registerData"
          :key="index"
          :label="item.text"
          :rules="item.rules"
          show-message
          :prop="item.fieldName"
        >
          <el-input v-if="item.type==='1'|| item.type==='text'" v-model="ruleForm[item.fieldName]" :disabled="item.fieldName==='mobile'&&isedit" :placeholder="item.placeholder"></el-input>
          <el-date-picker
            v-if="item.type==='3'"
            class="select-w2"
            v-model="ruleForm[item.fieldName]"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
          <el-checkbox-group v-if="item.type==='4'" v-model="ruleForm[item.fieldName]">
            <el-checkbox
              v-for="option in item.options"
              :key="`check${option.lable}`"
              :label="option.lable"
            >{{option.value}}</el-checkbox>
          </el-checkbox-group>
          <el-radio-group v-if="item.type==='5'" v-model="ruleForm[item.fieldName]">
            <el-radio
              v-for="option in item.options"
              :key="`ridio${option.lable}`"
              :label="option.lable"
            >{{option.value}}</el-radio>
          </el-radio-group>
          <el-select
            v-if="item.type === '2'"
            v-model="ruleForm[item.fieldName]"
            clearable
            placeholder="请选择"
            class="select-w2"
          >
            <el-option v-for="i in item.options" :key="i.value" :label="i.lable" :value="i.value"></el-option>
          </el-select>
          <el-select
            v-if="item.type === '6'"
            v-model="address.province"
            placeholder="请选择省份"
            @change="updateCity"
            class="select select-w"
          >
            <el-option
              v-for="(item, index) in province_list"
              :key="`province${index}`"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-select
            v-if="item.type === '6'"
            v-model="address.city"
            placeholder="请选择市区"
            @change="updateDistrict"
            class="select select-w"
          >
            <el-option
              v-for="(item, index) in city_list"
              :key="`city${index}`"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-select
            v-if="item.type === '6'"
            v-model="address.district"
            placeholder="请选择区域"
            class="select-w"
          >
            <el-option
              v-for="(item, index) in district_list"
              :key="`district${index}`"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-input v-if="item.type === '6'" v-model="address.detailedAddress" placeholder="请输入详细地址" class="el-select select-w2" @change="adressChange"></el-input>
          <el-input v-if="item.type === '7'" type="textarea" v-model="ruleForm[item.fieldName]"></el-input>
        </el-form-item>
      </el-form>
      <div class="user-title" v-if="!isedit   && isShowINvoice">发票信息</div>
      <el-form
        v-if="!isedit && isShowINvoice"
        :model="invoiceRuleForm"
        ref="invoiceruleForm"
        :rules="rules"
        label-position="top"
        label-width="100px"
        class="user-form"
      >
        <el-form-item label="发票类型" show-message prop="invoiceType">
          <el-select
            filterable
            v-model="invoiceRuleForm.type"
            clearable
            placeholder="请选择"
            class="select-w2"
            @change="choiceInvoiceType"
          >
            <el-option v-for="i in invoiceType" :key="i.value" :label="i.label" :value="i.value"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="invoiceRuleForm.type != 0">
          <el-form-item
            label="发票领取方式"
            show-message
            prop="collectionMethod"
            v-if="invoiceRuleForm.type != 3"
          >
            <el-select
              filterable
              v-model="invoiceRuleForm.collectionMethod"
              clearable
              placeholder="请选择"
              class="select-w2"
            >
              <el-option
                v-for="i in collectionMethod"
                :key="i.value"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票抬头" show-message prop="invoiceTitle">
            <el-input v-model="invoiceRuleForm.invoiceTitle"></el-input>
          </el-form-item>
          <el-form-item label="纳税人识别号" show-message prop="taxpayerIdentificationNumber">
            <el-input v-model="invoiceRuleForm.taxpayerIdentificationNumber"></el-input>
          </el-form-item>
          <el-form-item label="公司地址" show-message prop="address">
            <el-input v-model="invoiceRuleForm.address"></el-input>
          </el-form-item>
          <el-form-item label="电话" show-message prop="phone">
            <el-input v-model="invoiceRuleForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="开户行" show-message prop="accountBank">
            <el-input v-model="invoiceRuleForm.accountBank"></el-input>
          </el-form-item>
          <el-form-item label="账号" show-message prop="accountNumber">
            <el-input v-model="invoiceRuleForm.accountNumber"></el-input>
          </el-form-item>
          <el-form-item
            label="收件地址"
            show-message
            prop="recipientAddress"
            v-if="invoiceRuleForm.collectionMethod == 2 && invoiceRuleForm.type!=3"
          >
            <el-input
              type="textarea"
              v-model="invoiceRuleForm.recipientAddress"
              placeholder="如果需要邮寄发票，清填写收件信息"
            ></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" show-message prop="invoiceEmail" v-if="invoiceRuleForm.type == 3">
            <el-input v-model="invoiceRuleForm.invoiceEmail"></el-input>
          </el-form-item>
          <el-form-item label="备注" show-message prop="remark">
            <el-input type="textarea" v-model="invoiceRuleForm.remark"></el-input>
          </el-form-item>
        </template>
      </el-form>
     
      <div class="submit">
        <el-button class="m-btn" size="medium" round type="primary" @click="save">{{isedit?'保存':'提交'}}</el-button>
        <el-button class="pc-btn" size="medium"  type="primary" @click="save">{{isedit?'保存':'提交订单'}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import citys from '../../utils/city'
import Banner from '../../components/banner/index.vue'
import http from '@/utils/http'
import apis from '@/utils/apis'
export default {
  name: 'home',
  components: {
    Banner
  },
  data() {
    return {
      user: {},
      isedit: false,
      registerData: [
        { text: '姓名', rules: [{ required: true, message: '请输入姓名', trigger: 'blur' }], fieldName: 'name', type: 1 },
        { text: '单位', rules: [{ required: true, message: '请输入单位', trigger: 'blur' }], fieldName: 'company', type: 1 },
        { text: '部门', rules: [{ required: true, message: '请输入部门', trigger: 'blur' }], fieldName: 'department', type: 1 },
        { text: '科室', rules: [{ required: true, message: '请输入科室', trigger: 'blur' }], fieldName: 'offices', type: 1 },
        { text: '职务', rules: [{ required: true, message: '请输入职务', trigger: 'blur' }], fieldName: 'post', type: 1 },
        { text: '职称', rules: [{ required: true, message: '请输入职称', trigger: 'blur' }], fieldName: 'title', type: 1 },
        {          text: '手机号', rules: [{ required: true, message: '请输入手机号', trigger: 'blur' }, {
            pattern: /^1[3-9]{1}[0-9]{1}[0-9]{8}$/, message: "手机号格式错误", trigger: "blur"          }], fieldName: 'phone', type: 1        },
        {          text: '邮箱', rules: [{ required: true, message: '请输入邮箱', trigger: 'blur' },
          { pattern: /^([A-Za-z0-9_\-. ])+@ ([A-Za-z0-9_\-. ])+\. ([A-Za-z]{2,4})$/, message: '邮箱格式有误', trigger: 'blur' }], fieldName: 'email', type: 1        },
        { text: '单位详细地址', rules: [{ required: true, message: '请输入职称', trigger: 'blur' }], fieldName: 'area', type: 6 },
        {          text: '发票类型', rules: [{ required: true, message: '请输入职称', trigger: 'blur' }], fieldName: 'select', type: 2,
          options: [{ value: '选项1', label: '黄金糕' }, { value: '选项2', label: '双皮奶' }], default: '选项1'        },
        {          text: '活动类型', rules: [{ required: true, message: '请输入职称', trigger: 'blur' }], fieldName: 'actives', type: 4,
          options: [{ label: '黄金糕' }, { label: '双皮奶' }], default: []        },
        {          text: '活动', rules: [{ required: true, message: '请输入职称', trigger: 'blur' }], fieldName: 'activesradio', type: 5,
          options: [{ label: '线上品牌商赞助' }, { label: '线下场地免费' }], default: ''        },
        { text: '活动时间', rules: [{ required: true, message: '请输入职称', trigger: 'blur' }], fieldName: 'area', type: 3, default: '' },
        { text: '活动形式', rules: [{ required: true, message: '请输入职称', trigger: 'blur' }], fieldName: 'area', type: 7, default: '' }
      ],
      ruleForm: {},
      province_list: [],
      city_list: [],
      district_list: [],
      address: {
        province: '',
        city: '',
        district: '',
        detailedAddress: ''
      },
      invoiceRuleForm: {
        type: 0,
        collectionMethod: '',
        invoiceTitle: '',
        taxpayerIdentificationNumber: '',
        address: '',
        phone: '',
        accountBank: '',
        accountNumber: '',
        recipientAddress: '',
        invoiceEmail: '',
        remark: ''
      },
      rules: {
        type: [{ required: true, message: '请输入发票类型', trigger: 'blur' }],
        collectionMethod: [{ required: true, message: '请选择发票领取方式', trigger: 'blur' }],
        invoiceTitle: [{ required: true, message: '请输入发票抬头', trigger: 'blur' }],
        taxpayerIdentificationNumber: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }],
        address: [{ required: true, message: '请输入公司地址', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入电话', trigger: 'blur' }],
        accountBank: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
        recipientAddress: [{ required: true, message: '请输入收件地址', trigger: 'blur' }],
        invoiceEmail: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { pattern: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/, message: '邮箱格式有误', trigger: 'blur' }
        ],
        accountNumber: [{ required: true, message: '请输入账号', trigger: 'blur' }]
      },
      invoiceType: [
        {
          value: 0,
          label: '暂不填写'
        },
        {
          value: 1,
          label: '增值税普通发票'
        },
        {
          value: 2,
          label: '增值税专用发票'
        },
        {
          value: 3,
          label: '增值税电子普通发票'
        }
      ],
      collectionMethod: [
        {
          value: 1,
          label: '现场领取'
        },
        {
          value: 2,
          label: '发票邮寄'
        }
      ],
      bannerData: {},
      whiteDiscountAmount: 0,
      isShowINvoice: false
    }

  },
  computed: {
    meetingId() {
      return this.$store.state.meetingId || localStorage.getItem('meetingId')
    }
    // user(){
    //   return this.$store.state.userinfo
    // }
  },
  methods: {
    //选择发票类型
    choiceInvoiceType(_val) {
      if (_val == 2) { // 增值税专用发票
        this.rules.address[0].required = true
        this.rules.phone[0].required = true
        this.rules.accountBank[0].required = true
        this.rules.accountNumber[0].required = true
      } else { // 其他
        this.rules.address[0].required = false
        this.rules.phone[0].required = false
        this.rules.accountBank[0].required = false
        this.rules.accountNumber[0].required = false
      }
    },
    updateCity() {
      this.city_list = Object.keys(citys[this.address.province])
    },
    updateDistrict() {
      this.district_list = citys[this.address.province][this.address.city]
    },
    adressChange() {
      this.ruleForm.companyAddress = this.address.province + ' ' + this.address.city + ' ' + this.address.district + ' ' + this.address.detailedAddress
    },
    async getMeetingInfo() {
      const res = await http.get(`${apis.getMeetingInfo}/${this.meetingId}`)
      this.bannerData = res.result.meeting
    },
    async getSignUpInfo() {
      const res = await http.get(`${apis.getsignUpInfo}/${this.meetingId}`)
      if (res.code === 0) {
        let registerData=[]
        res.result.meetingConfig.audienceConfig.customConfigList.forEach(ele => {
          if(ele.must){ //需要显示
              let obj = {
                text: ele.name,
                rules: [{ required: ele.required, message: ele.annotation, trigger: 'blur' }],
                fieldName: ele.fieldName,
                type: ele.type,
                options: ele.option,
                placeholder: ele.annotation
              }
              if (ele.type === '6') {
                obj.fieldName = 'companyAddress'
              }
              if (ele.fieldName === 'mobile') {
                obj = {
                  text: ele.name,
                  rules: [{ required: ele.required, message: ele.annotation, trigger: 'blur' },
                  { pattern: /^1[3-9]{1}[0-9]{1}[0-9]{8}$/, message: "手机号格式错误", trigger: "blur" }],
                  fieldName: ele.fieldName,
                  type: '1',
                  placeholder: ele.annotation
                }
              }
              if (ele.fieldName === 'email') {
                obj = {
                  text: ele.name,
                  rules: [{ required: ele.required, message: ele.annotation, trigger: 'blur' },
                  { pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message: '邮箱格式有误', trigger: 'blur' }],
                  fieldName: ele.fieldName,
                  type: '1',
                  placeholder: ele.annotation
                }
              }
              registerData.push(obj)
          }
        })

        this.registerData = registerData
        console.log(this.registerData)
        if(this.isedit) {
           return
        }
        this.registerData.forEach(element => {
          if(element.type==='4'){
              this.$set(this.ruleForm, element.fieldName, element.default || [])
          }else{
              this.$set(this.ruleForm, element.fieldName, element.default || '')
          }
          
        });
      }

    },
    save() {
      console.log(this.ruleForm)
      const ticket = JSON.parse(localStorage.getItem('ticket'))
      console.log(ticket)
      this.ruleForm.companyAddress = this.address.province + ' ' + this.address.city + ' ' + this.address.district + ' ' + this.address.detailedAddress
      const data = {
        "administrativeOffice": this.ruleForm.administrativeOffice || "",
        "companyAddress": this.ruleForm.companyAddress || "",
        "companyName": this.ruleForm.companyName || "",
        "contacts": this.ruleForm.contacts || "",
        "departmentName": this.ruleForm.departmentName || "",
        "email": this.ruleForm.email || "",
        "gender": this.ruleForm.gender || 0,
        "job": this.ruleForm.job || "",
        "mobile": this.ruleForm.mobile || "",
        "position": this.ruleForm.position || "",
        "ticketId": ticket&&ticket.id,
        "ticketName": ticket&&ticket.ticketName
        // "amount": ticket.price,
        // "discountAmount": ticket.discounMoney,
        // "whiteDiscountAmount":this.whiteDiscountAmount
      }
      data.customMap = JSON.stringify(this.ruleForm)
      data.meetingId = this.meetingId
      this.$store.commit('SET_REGISTER_PHONE', this.ruleForm.mobile)
      if(this.isedit) {
        data.id = localStorage.getItem('audienceId')
      }
      // if (data.address) {
      //   data.address = this.address.province + ' ' + this.address.city + ' ' + this.address.district
      // }
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          console.log(this.invoiceRuleForm)
          if (this.invoiceRuleForm.type == 0) {
            data.invoice = {}
            data.invoice.type = 0
            data.invoice.meetingId = this.meetingId
            // localStorage.setItem('userInfo',JSON.stringify(data))
            // this.$router.push('/tickets_pay')
            // const url = apis.saveUser
            const url = this.isedit?apis.editUserInfo : apis.saveUserOrder
            const res = await http.post(url, data)
            if (res.code === 0) {
              // this.$message({
              //     message: '恭喜你，报名成功',
              //     type: 'success'
              // });
              if(this.isedit) {
                  this.$router.push('/profile')
                  return
              }
              this.$refs['ruleForm'].resetFields()
              localStorage.setItem('chooseTicket', JSON.stringify(res.audienceOrderResult))
              this.$router.push('/tickets_pay')
            } else {
              this.$alert(res.msg, '',{
                    showClose: false
                  })
            }
          } else {
            this.$refs['invoiceruleForm'].validate(async (valid) => {
              if (valid) {
                data.invoice = this.invoiceRuleForm
                data.invoice.meetingId = this.meetingId
                // localStorage.setItem('userInfo',JSON.stringify(data))
                // this.$router.push('/tickets_pay')
                // const url = apis.saveUser
                const url = this.isedit?apis.editUserInfo : apis.saveUserOrder
                const res = await http.post(url, data)
                if (res.code === 0) {
                  // this.$message({
                  //   message: '恭喜你，报名成功',
                  //   type: 'success'
                  // });
                  if(this.isedit) {
                      this.$router.push('/profile')
                      return
                  }
                  this.$refs['ruleForm'].resetFields()
                  // localStorage.setItem('audienceId',res.id)
                  localStorage.setItem('chooseTicket', JSON.stringify(res.audienceOrderResult))
                  this.$router.push('/tickets_pay')
                } else {
                  this.$alert(res.msg, '',{
                    showClose: false
                  })
                }
              } else {
                this.$alert('请完成发票信息填写', '',{
                    showClose: false
                  })
              }
            })
          }


        } else {
          this.$alert('请填写完整报名信息', '',{
                    showClose: false
                  })
          return false;
        }
      })

    },
    // 个人信息
    async getUserinfo() {
      console.log('this.user', this.user)
      let params = {
        audienceId: localStorage.getItem('audienceId')
      }
      const res = await http.get(`${apis.getEditUserinfo}/${this.meetingId}`, { params })
      console.log('个人信息', res)
      this.$nextTick(()=>{
          this.ruleForm = JSON.parse(res.audience.customMap)
          console.log(JSON.parse(res.audience.customMap), this.ruleForm)
          this.address.province = this.ruleForm.companyAddress.split(' ')[0]
          this.address.city = this.ruleForm.companyAddress.split(' ')[1]
          this.address.district = this.ruleForm.companyAddress.split(' ')[2]
          this.address.detailedAddress = this.ruleForm.companyAddress.split(' ')[3]
      })
      
    },
    async getWhiteList(val) {
       const res = await http.get(`${apis.getWhiteList}/${this.meetingId}`)
       console.log(res)
       if(res.code === 0) {
         res.whiteList.forEach((ele) => {
            if(ele.list.includes(val)){
                this.whiteDiscountAmount = ele.price
                localStorage.setItem('whiteDiscount',JSON.stringify({whiteDiscountAmount:ele.price, whiteDiscountName:ele.name,whiteDiscountId: ele.id}))
            }
         })
       }
    },
    getvalue(item) {
        console.log(item,2222)
        if(item.fieldName === 'companyName') {
            this.getWhiteList(this.ruleForm.companyName)
        }
    },
    async getInvoiceConfig() {
               const res = await http.get(`/renren-fast/app/audience/invoiceConfigInfo/${this.meetingId}`)
               const invoiceType = res.invoiceConfig.invoiceType.split('-')
               const receiveType = res.invoiceConfig.receiveType.split('-')
               console.log(invoiceType,'2222')
               if(!res.invoiceConfig.invoiceType){
                  this.isShowINvoice = false
                  return
               }else{
                  this.isShowINvoice = true
               }
               this.invoiceType = [{
                 value: 0,
                 label:'暂不填写'
               }]
               const type=invoiceType.map(ele=>{
                   return {
                       value: ele,
                       label: ele == 1? '增值税普通发票': ele == 2?'增值税专用发票':ele == 3?'增值税电子普通发票':'未填写'
                   }
               })
               this.invoiceType = [...this.invoiceType, ...type]

               this.collectionMethod = receiveType.map(ele=>{
                   return {
                       value: ele,
                       label: ele==1?'现场领取':ele==2?'发票邮寄':''
                   }
               })
            }
  },
  created() {
    console.log('this.$route', this.$route)

    this.province_list = Object.keys(citys)
    this.isedit = this.$route.query.isedit == 1 ? true : false
    this.getMeetingInfo()
    this.getSignUpInfo()
    this.getInvoiceConfig()
    if (this.isedit) {
      this.user = JSON.parse(localStorage.getItem('userinfo'))
      this.getUserinfo()
    }
    
  }
}
</script>
<style lang="stylus" scoped>
.back-btn {
  color: #606060;
  font-size: 27px;
  margin: 10px;
}

.user-form {
  /deep/ .el-form-item__error {
    font-size: 28px;
  }
}

.el-select-dropdown__item {
  padding: 15px 0;
  box-sizing: content-box;
  font-size: 28px;
}

.home {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  box-sizing: border-box;
}

.user {
  background: #ffffff;
  margin-top: 30px;
  padding: 26px 20px;

  .user-title {
    font-size: 32px;
    padding-bottom: 18px;
    border-bottom: 1px dashed rgba(199, 199, 199, 1);
  }

  .user-form {
    margin-top: 20px;
    font-size: 32px;

    /deep/ .el-form-item__label {
      font-size: 32px;
      padding-bottom: 18px;
    }

    /deep/ .el-radio__label {
      font-size: 32px;
      padding-bottom: 18px;
    }

    /deep/ .el-input__inner {
      height: 60px;
      line-height: 60px;
      font-size: 30px;
    }

    /deep/ .el-textarea__inner {
      font-size: 30px;
    }

    /deep/ .el-form-item {
      margin-bottom: 35px;
    }
  }
}

.select-w {
  width: 225px;
  height: 60px;
}

.select-w2 {
  width: 710px;
  margin-top: 20px;
}

.select {
  margin: 0px 15px 0px 0px;
}

.adress {
  margin-top: 10px;
}

/deep/ .el-checkbox__inner {
  width: 20px;
  height: 20px;
}

/deep/ .el-checkbox__label {
  font-size: 28px;
}

/deep/ .el-radio__inner {
  width: 30px;
  height: 30px;
}

.submit {
  display: flex;
  justify-content: center;

  /deep/ .el-button--medium {
    width: 200px;
    height: 50px;
    border-radius: 50px;
    box-sizing: content-box;
    font-size: 30px;
  }
}

.pc-title {
  display: none;
}

.m-btn {
}

.pc-btn {
  display: none;
}

@media screen and (min-width: 800px) {
  .back-btn {
    font-size: 24px;
    margin-bottom: 20px;
    margin-left: 20px;
  }

  .m-btn {
    display: none;
  }

  .pc-btn {
    display: block;
    width: 240px;
    height: 60px;
    background: #2852A6;
    border-radius: 10px !important;
    padding: 0;
    margin: 70px 0;
  }

  .user-form {
    /deep/ .el-form-item {
      position: relative;
    }

    /deep/ .el-form-item__error {
      font-size: 22px;
      // position: absolute;
      // right: 0;
      // text-align: right;
      // top: -30px;
    }
  }

  .el-select-dropdown__item {
    padding: 0;
    box-sizing: content-box;
    font-size: 22px;
    height: 3vw;
    line-height: 3vw;
    font-size: 20px;
    padding-left: 26px;
  }

  .home {
    width: 900px;
    margin: 0 auto;
    min-height: 100vh;
    background: #fff;
    box-sizing: border-box;
    padding-bottom: 100px;
  }

  .pc-title {
    display: block;
    padding: 36px 30px 26px 30px;
    font-size: 24px;
    color: #343434;
  }

  .user {
    background: #ffffff;
    margin: 0 30px;
    border: 1px solid #ACACAC;
    border-radius: 10px;
    color: #000;
    padding: 30px 32px 10px;

    .user-title {
      font-size: 24px;
      padding-bottom: 10px;
      border-bottom: 1px dashed rgba(199, 199, 199, 1);
      margin-top: 30px;
    }

    .user-form {
      margin-top: 0px;
      font-size: 24px;

      /deep/ .el-form-item__label {
        font-size: 24px;
        height: 50px;
        line-height: 50px;
        padding-top: 5px;
        padding-bottom: 0;
      }

      /deep/ .el-input__inner {
        height: 50px;
        line-height: 50px;
        font-size: 22px;
      }

      /deep/ .el-radio__label {
        font-size: 22px;
        padding-bottom: 0px;
      }

      /deep/ .el-textarea__inner {
        font-size: 22px;
      }

      /deep/ .el-form-item__content {
        line-height: 4.5vw;
      }

      /deep/ .el-form-item {
        margin-bottom: 0px;
      }

      /deep/ .el-input__icon {
        line-height: 4.3vw;
      }
    }
  }

  .select-w {
    width: 230px;
    height: 60px;
  }

  .select-w2 {
    width: 710px;
    margin-top: 0px;
  }

  .select {
    margin: 0px 15px 15px 0px;
  }

  .adress {
    margin-top: 10px;
  }

  /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  /deep/ .el-checkbox__label {
    font-size: 28px;
  }

  /deep/ .el-radio__inner {
    width: 20px;
    height: 20px;
  }

  .submit {
    display: flex;
    justify-content: center;

    /deep/ .el-button--medium {
      width: 200px;
      height: 50px;
      border-radius: 50px;
      box-sizing: content-box;
      font-size: 30px;
    }
  }
}
</style>
